import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { tipoServicioAlimentacionOrigenApi } from '../api/tipoServicioAlimentacionOrigenApi';

export const useTipoServicioAlimentacionOrigen = () => {
  const [relaciones, setRelaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Obtener relaciones por cliente (proyecto viene del header X-Proyecto-ID)
  const fetchRelacionesByCliente = useCallback(async (clienteId) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoServicioAlimentacionOrigenApi.getByCliente(clienteId);
      setRelaciones(data);
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al obtener relaciones';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Crear relación
  const createRelacion = useCallback(async (relacionData) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await tipoServicioAlimentacionOrigenApi.create(relacionData);
      // Recargar relaciones después de crear
      if (relacionData.cliente_id) {
        await fetchRelacionesByCliente(relacionData.cliente_id);
      }
      toast.success('Relación creada exitosamente');
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al crear relación';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, [fetchRelacionesByCliente]);

  // Eliminar relación (proyecto viene del header X-Proyecto-ID)
  const deleteRelacion = useCallback(async (clienteId, tipoServicioAlimentacionId, tipoOrigenId) => {
    setLoading(true);
    setError(null);
    
    try {
      await tipoServicioAlimentacionOrigenApi.delete(clienteId, tipoServicioAlimentacionId, tipoOrigenId);
      setRelaciones(prev => 
        prev.filter(rel => 
          !(rel.cliente_id === clienteId && 
            rel.tipo_servicio_alimentacion_id === tipoServicioAlimentacionId && 
            rel.tipo_origen_id === tipoOrigenId)
        )
      );
      toast.success('Relación eliminada exitosamente');
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Error al eliminar relación';
      setError(errorMessage);
      toast.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // Limpiar error
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    // Estado
    relaciones,
    loading,
    error,
    
    // Acciones
    fetchRelacionesByCliente,
    createRelacion,
    deleteRelacion,
    clearError,
  };
};

